import { IonButton, IonIcon, IonModal } from '@ionic/react';
import { alertCircleOutline, close } from 'ionicons/icons';
import React from 'react';
import './ExitConfirmModal.css';

type ExitConfirmModalProps = {
  isOpen: boolean;
  onStay: () => void;
  onLeave: () => void;
};

const ExitConfirmModal: React.FC<ExitConfirmModalProps> = ({ isOpen, onStay, onLeave }) => {
  return (
    <IonModal className="small-modal" isOpen={isOpen} onDidDismiss={onStay}>
      <div className="exit-confirm-content">
        <IonButton fill="clear" className="exit-confirm-close" onClick={onStay}>
          <IonIcon icon={close} />
        </IonButton>

        <div className="exit-confirm-icon"><IonIcon color="danger" icon={alertCircleOutline} /></div>

        <div className="exit-confirm-title">
          Tem certeza que deseja sair?
        </div>

        <div className="exit-confirm-text">
          Você ainda não concluiu todas as configurações. Sua loja pode não receber pedidos corretamente.
        </div>

        <div className="exit-confirm-buttons">
          <IonButton fill="outline" className="exit-confirm-btn-leave" onClick={onLeave}>
            Sair
          </IonButton>
          <IonButton className="exit-confirm-btn-stay" onClick={onStay}>
            Continuar configurando
          </IonButton>
        </div>
      </div>
    </IonModal>
  );
};

export default ExitConfirmModal;
